var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-draw-page"},[(_vm.loadingPins || _vm.loadError)?_c('div',{staticClass:"map-status",class:{ error: _vm.loadError }},[_vm._v(" "+_vm._s(_vm.loadError || 'Loading map pins...')+" ")]):_vm._e(),_c('div',{ref:"mapDraw",staticClass:"map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }